<template>
    <div class="order-success__addresses">
        <div class="order-success__address card address-card">
            <div class="address-card__badge tag-badge tag-badge--theme">
                Shipping Address
            </div>
            <div class="address-card__body">
                <div class="address-card__name">{{shippingInfo.customer_name}}</div>
                <div class="address-card__row">
                        {{shippingInfo.customer_address}}<br>
                        {{shippingInfo.customer_city}}, {{shippingInfo.customer_state}}
                    {{shippingInfo.customer_zipcode}} </div>
                <div class="address-card__row">
                    <div class="address-card__row-title">Phone Number</div>
                    <div class="address-card__row-content">{{shippingInfo.customer_mobile}}</div>
                </div>
                <div class="address-card__row">
                    <div class="address-card__row-title">Email Address</div>
                    <div class="address-card__row-content">{{shippingInfo.customer_email}}</div>
                </div>
            </div>
        </div>
        <div class="order-success__address card address-card">
            <div class="address-card__badge tag-badge tag-badge--theme">
                Billing Address
            </div>
            <div class="address-card__body">
                <div class="address-card__name">{{billingInfo.customer_name}}</div>
                <div class="address-card__row">
                        <span v-if="billingInfo.customer_address != ''">{{billingInfo.customer_address}}<br></span>
                        <span v-if="billingInfo.customer_address2 != ''">{{billingInfo.customer_address2}}<br></span>
                        {{billingInfo.customer_city}}, {{billingInfo.customer_state}}
                    {{billingInfo.customer_zipcode}}
                    </div>
                <div class="address-card__row">
                    <div class="address-card__row-title">Phone Number</div>
                    <div class="address-card__row-content">{{billingInfo.customer_mobile}}</div>
                </div>
                <div class="address-card__row">
                    <div class="address-card__row-title">Email Address</div>
                    <div class="address-card__row-content">{{billingInfo.customer_email}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        billingInfo : {
            type : Object,
            required: true
        },
        shippingInfo : {
            type : Object,
            required: true
        }
    }
}
</script>